import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import GlobalLayout from '../GlobalLayout';
import { getColdef, updateColdef, createColdef } from '../../services/admin_api';

// ACE core & modes
import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';
import AceEditor from 'react-ace';

const EditColdef = () => {
    const { queryId } = useParams();
    const navigate = useNavigate();

    const initialQueryId = queryId ? parseInt(queryId, 10) : null;

    const [coldefData, setColdefData] = useState({
        id: null,
        query_id: initialQueryId,
        content: '', // JSON string
    });
    const [isEdit, setIsEdit] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchColdef = async () => {
            setLoading(true);
            try {
                const data = await getColdef(initialQueryId);
                if (data && data.id !== undefined && data.id !== null) {
                    setColdefData({
                        id: parseInt(data.id, 10),
                        query_id: parseInt(data.query_id, 10),
                        content: typeof data.content === 'string' ? data.content : JSON.stringify(data.content, null, 2),
                    });
                    setIsEdit(true);
                } else {
                    // Pas de coldef existante -> mode création
                    setColdefData(prev => ({
                        ...prev,
                        id: null,
                        content: prev.content || ''
                    }));
                    setIsEdit(false);
                }
                setError('');
            } catch (e) {
                console.error(e);
                // Erreur -> on reste en création
                setIsEdit(false);
                setError('Erreur lors du chargement de la définition des colonnes.');
            } finally {
                setLoading(false);
            }
        };
        if (initialQueryId) {
            fetchColdef();
        } else {
            setLoading(false);
            setIsEdit(false);
        }
    }, [initialQueryId]);

    const handleContentChange = (newValue) => {
        setColdefData({ ...coldefData, content: newValue });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        // Validation JSON basique
        try {
            if (coldefData.content.trim() === '') {
                throw new Error('La définition JSON est vide');
            }
            JSON.parse(coldefData.content);
        } catch (e) {
            alert('JSON invalide: ' + e.message);
            return;
        }

        try {
            const payload = {
                query_id: coldefData.query_id != null ? parseInt(coldefData.query_id, 10) : null,
                content: JSON.parse(coldefData.content),
            };
            if (isEdit && coldefData.id != null) {
                await updateColdef(parseInt(coldefData.id, 10), payload);
                alert('Coldef mise à jour avec succès.');
            } else {
                await createColdef(payload);
                alert('Coldef créée avec succès.');
            }
            navigate(-1);
        } catch (e) {
            console.error(e);
            setError(`Erreur lors de la ${isEdit ? 'mise à jour' : 'création'} de la Coldef.`);
        }
    };

    if (loading) return <div>Chargement...</div>;

    return (
        <GlobalLayout>
            <div style={{ padding: '1rem', margin: '0 auto' }}>
                <h1>{isEdit ? 'Éditer la Coldef' : 'Nouvelle Coldef'}</h1>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <InputLabel style={{ marginBottom: 8 }}>Contenu (JSON)</InputLabel>
                            <AceEditor
                                mode="json"
                                theme="monokai"
                                name="ace-editor-coldef"
                                onChange={handleContentChange}
                                value={coldefData.content}
                                width="100%"
                                height="800px"
                                setOptions={{ useWorker: false }}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Button variant="contained" color="primary" type="submit">
                                {isEdit ? 'Enregistrer' : 'Créer'}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </GlobalLayout>
    );
};

export default EditColdef;
